import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20digital%20landscape%20with%20soft%20gradients%20of%20amber%20and%20cream%2C%20flowing%20organic%20shapes%2C%20minimalist%20art%20style%2C%20elegant%20atmospheric%20composition%2C%20subtle%20texture%20with%20warm%20light%20rays&width=1600&height=800&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          立即探索最全国产内容库
        </h2>
        <p className="text-background-100/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
          国产一区汇聚海量优质国产原创内容，无论热门资源还是冷门珍藏，这里都有您想要的精彩。立即开始您的探索之旅吧！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/zuixin-jingxuan"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览最新精选
          </Link>
          <Link
            to="/category/remen-tuijian"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看热门推荐
          </Link>
        </div>
      </div>
    </section>
  );
}